import React from 'react';
import SearchIcon from 'assets/images/ic_search.svg';
import { ic_close_small_black as BlackCloseIcon } from 'app/widgets/SVGs';
import ClickOutside from 'app/widgets/ClickOutside';
import { Input } from '@progress/kendo-react-inputs';
import { Card, CardBody } from '@progress/kendo-react-layout';
import { Model } from 'types/entities/Resources';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  searchTerm: string;
  searchFor: string;
  searchResults: Model[];
  setSearchTerm: (value: string) => void;
}

export default function SearchBox({
  searchTerm,
  searchFor,
  searchResults,
  setSearchTerm,
}: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div className="search-box">
      <ClickOutside
        className="search-with-options"
        onClickOutside={() => {
          setIsExpanded(false);
        }}
      >
        <div className="site-search open">
          <span className="search-icon">
            <img alt="Search" src={SearchIcon}></img>
          </span>

          <div className="search-input">
            <Input
              id="resourcesSearch"
              name="resourcesSearch"
              placeholder={t('search_for', { s: searchFor })}
              value={searchTerm}
              onChange={e => setSearchTerm(e.value)}
              onFocus={() => setIsExpanded(true)}
            />
            {searchTerm && (
              <span
                className="search-icon-close"
                onClick={() => {
                  setSearchTerm('');
                }}
              >
                <BlackCloseIcon />
              </span>
            )}
          </div>
        </div>

        <div className="search-options">
          {isExpanded && (
            <Card>
              <CardBody>
                {!!searchResults.length ? (
                  searchResults.map(({ model }) => {
                    return (
                      <div
                        key={model}
                        onClick={() =>
                          navigate(`/resources/check-redirect/p/${model}`)
                        }
                      >
                        {model}
                      </div>
                    );
                  })
                ) : (
                  <div className="not-found-message">
                    {t('no_result_for', { s: searchTerm })}
                  </div>
                )}
              </CardBody>
            </Card>
          )}
        </div>
      </ClickOutside>
    </div>
  );
}
